/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      color: '#D3A414',
      text: 'Contact Us',
      font: {
        family: 'AUTO',
      },
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop'],
    },
    {
      mode: 'modal',
      icon: 'phone',
      color: '#D3A414',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['tablet', 'mobile'],
    },
  ],
  modal_options: {
    header_text:
      '<img style="max-width:300px;" src="https://lirp.cdn-website.com/46887068/dms3rep/multi/opt/web2-270w.png">',
    header_color: '#ffffff',
    description_text: 'Concrete is our adventure!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: 'Call (803) 408-5505',
        description: 'South Carolina',
        link: 'tel:+18034085505',
        txt_color_hover: '#D3A414',
        bg_color: '#D3A414',
        class_list: ['call-us-south-carolina'],
        icon: 'phone',
      },
      {
        title: 'Call (865) 315-8455',
        description: 'Tennessee',
        link: 'tel:+18653158455',
        txt_color_hover: '#D3A414',
        bg_color: '#D3A414',
        class_list: ['call-us-tennessee'],
        icon: 'phone',
      },
      {
        title: 'CONTACT',
        link: '/contact',
        bg_color: '#D3A414',
        txt_color_hover: '#D3A414',
        class_list: ['contact'],
        icon: 'email',
      },
    ],
    footer_text:
      'Our full service decorative concrete company is committed to quality and service. Contact us to get started today!',
    footer_color: '',
  },
}).then((_) => {
  /* ConvertBoost© Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us-south-carolina',
      action: 'Call South Carolina (803) 408-5505 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us-tennessee',
      action: 'Call Tennessee (865) 315-8455 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .contact',
      action: 'Contact - ConvertBoost©',
      event: 'click',
    },
  ]);
});
